import { MdKeyboard } from "react-icons/md";
import { Route as ListeningRoute } from "./Listening/Route";
import { Route as ShortcutsRoute } from "./Shortcuts/Route";

import { HeadSetSVG } from "../../../components/svg/HeadSetSVG";

import { createLinksAndRoutes } from "../../../../utils/createLinksAndRoutes";
const list = [
  {
    path: "listening",
    link: {
      color: "#3e4ec9",
      title: "Listening",
      Icon: HeadSetSVG,
    },
    component: ListeningRoute,
  },
  {
    path: "shortcuts",
    link: {
      color: "#c9a4c4",
      title: "Shortcuts",
      Icon: MdKeyboard,
    },
    component: ShortcutsRoute,
  },
];

export const { links, routes } = createLinksAndRoutes(list);
